export default __webpack_public_path__ + "static/media/Capitals.3e107d49.png";